module.exports = __webpack_public_path__ + "img/frame (169).2ed9a045.jpg";